module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic13.c3b7000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic13.png
// module id = 564
// module chunks = 1